import styled from 'styled-components';
import Fleet from '@pedidosya/web-fenix/icons/Fleet';

const FleetUtilisationIcon = styled(Fleet)`
  margin-left: -${({ theme }) => theme.spacing(1.5)};
  fill: ${({ theme }) => theme.colors.textSecondary};
  position: relative;
  bottom: ${({ theme }) => theme.spacing(1)};
`;

export default FleetUtilisationIcon;
